module.exports = __webpack_public_path__ + "img/icon_callendar.53446715.svg";